'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFromVisitor = undefined;

var _isSenderType = require('./isSenderType');

var _senderTypes = require('../constants/senderTypes');

var isFromVisitor = exports.isFromVisitor = (0, _isSenderType.isSenderType)(_senderTypes.VISITOR);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isFromVisitor.js
// module id = 110
// module chunks = 2 3